import React, { useEffect, useState, useRef } from "react"
import { BsChevronDown } from "react-icons/bs";
import { getCity, setCity } from "../../../../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import cityStyles from "./City.module.css";

const CitySelect = () => {
  const dispatch = useDispatch();
  const focusedCityRef = useRef(null);
  const [displayCitySelect, setDisplayCitySelect] = useState(false);
  const [searchCity, setSearchCity] = useState("");

  let citiesObj = useSelector((state) => state.navCityList.navCities);
  let cities = citiesObj?.cities ?? [];

  const cityState = useSelector((state) => state.cityOnTopNav.citySelect);

  useEffect(() => {
    let city = localStorage.getItem("city");
    // console.log("city", city);
    if (city) {
      dispatch(setCity(city));
      setSearchCity(city);
    }
    else {
      // dispatch(setCity("Noida"));
      // setSearchCity("Noida");
    }

    // console.log(getCity());
    dispatch(getCity());
  }, []);

  useEffect(() => {
    if (!cityState) {
      setSearchCity("");
      localStorage.removeItem("city");
    }
    else {
      setSearchCity(cityState);
      localStorage.setItem("city", cityState);
    }
    document.getElementById("header-city-input").style.width = cityState ? cityState.length + "ch" : "9ch";
  }, [cityState])

  const handleSearchCityFocus = () => {
    setSearchCity("");
    // localStorage.removeItem("city");
    // dispatch(setCity(""));
    document.getElementById("header-city-input").style.width = "9ch";
    !displayCitySelect && setDisplayCitySelect(true);
  };

  const handleCitySelectOnBlur = () => {
    setTimeout(() => {
      setDisplayCitySelect(false);
    }, 250)
  }

  const handleSearchCityChange = (e) => {
    const city = e.target.value.replace(" ", "_");
    setSearchCity(city);
    // if (city === "") {
    //   setSelectedCity("");
    //   dispatch(setCity(""))
    // }
    focusedCityRef.current = document.getElementById("city-list");
  }

  const handelCityNameClick = (city) => {
    // console.log("Selected city", city)
    // localStorage.setItem("city", city);
    // setSearchCity(city);
    // setSelectedCity(city);
    dispatch(setCity(city != "" ? city : ""));
    setDisplayCitySelect(false);
    document.getElementById("header-city-input").blur();
  };

  // Case When User Input Anything Into Search City Bar and them click outside
  useEffect(() => {
    if (
      // selectedCity === ""&& 
      // searchCity !== "" && 
      document.activeElement !== document.getElementById("header-city-input")
    ) {
      setSearchCity(cityState);
      document.getElementById("header-city-input").style.width = cityState ? cityState.length + "ch" : "9ch";
    }
  }, [displayCitySelect])

  const handleCityFocus = (e) => {
    if (focusedCityRef.current === document.getElementById("city-list") && e.keyCode === 40) {
      focusedCityRef.current = document.getElementById("city-list").firstElementChild;
      focusedCityRef.current.style.backgroundColor = "#f0f0f0";
      return;
    }
    let focusedCity = focusedCityRef.current;
    if (e.keyCode === 13) {
      focusedCity.click();
      return;
    }
    focusedCity.style.backgroundColor = "#fff";
    if (e.keyCode === 40 || e.keyCode === 38) {
      // console.log("focusedCity", focusedCity);
      if (e.keyCode === 40 && focusedCity.nextElementSibling) {
        focusedCity = focusedCity.nextElementSibling;
      }
      else if (e.keyCode === 38 && focusedCity.previousElementSibling) {
        focusedCity = focusedCity.previousElementSibling;
      }
      focusedCity.style.backgroundColor = "#f0f0f0";
      focusedCityRef.current = focusedCity
    }
  }

  const cityNameMouseOver = (e) => {
    let focusedCity = focusedCityRef.current;
    focusedCity.style.backgroundColor = "#fff";
    focusedCity = e.target;
    focusedCity.style.backgroundColor = "#f0f0f0";
    focusedCityRef.current = focusedCity
  }

  // console.log("Focused Ref", focusedCityRef);

  const getTextDecoration = () => {
    return document?.activeElement === document?.getElementById("header-city-input")
      ? "none"
      : cityState === ""
        ? "none"
        : "underline"
  }

  useEffect(() => {
    document.getElementById("header-city-input").style.textDecoration = getTextDecoration();
  })

  return (
    <div
      className={cityStyles.citySelectHome}
      onBlur={handleCitySelectOnBlur}
      id="city-div"
    >
      <input
        type="text"
        id="header-city-input"
        style={{ width: "9ch" }}
        className={cityStyles.cityNameInput}
        value={searchCity.replace("_", " ")}
        onFocus={(e) => { handleSearchCityFocus(e) }}
        onChange={(e) => handleSearchCityChange(e)}
        placeholder="Search City"
        onKeyDown={handleCityFocus}
        spellCheck="false"
        autoComplete="off"
      />
      <span
        className={cityStyles.dropDownSvgSpan}
        // onBlur={handleCitySelectOnBlur}
        onClick={() => {
          document.getElementById("header-city-input").focus();
        }}
      >
        <BsChevronDown
          className={cityStyles.dropDownSvg}
          style={{ fontSize: "1.2rem" }}
        />
      </span>
      {displayCitySelect ? (
        <div className={cityStyles.divCity} id="city-list" ref={focusedCityRef}>
          <span
            onClick={() => handelCityNameClick("")}
            // ref={focusedCityRef}
            onMouseOver={cityNameMouseOver}
            className={cityStyles.cityName}
          >
            Select City
          </span>
          {cities
            .filter((city) => {
              let res;
              city.split("_").forEach((partialName, index) => {
                if (res === true)
                  return;
                if (partialName.length < searchCity.length) {
                  res = false;
                  return;
                }
                res = true;
                for (let i = 0; i < searchCity.length; i++) {
                  if (partialName[i].toLowerCase() !== searchCity[i].toLowerCase()) {
                    res = false;
                    break;
                  }
                }
              });
              return res;
            })
            .map((filteredCity, index) => {
              return (
                <span
                  onClick={() => handelCityNameClick(filteredCity)}
                  key={index}
                  onMouseOver={cityNameMouseOver}
                  className={cityStyles.cityName}
                >
                  {filteredCity.replaceAll("_", " ")}
                </span>
              );
            })}
        </div>
      ) : null}
    </div>
  );
};

export default CitySelect;
